import { DatalayerService } from '@analytics/datalayer';
import type { OnChanges } from '@angular/core';
import { Component, ElementRef, inject, Input } from '@angular/core';
import { NavigationExtras } from '@angular/router';
import {
  ComponentRendering,
  getFieldValue,
  TextField,
} from '@sitecore-jss/sitecore-jss-angular';

@Component({
  selector: 'wl-rich-text-wrapper[field]',
  templateUrl: './rich-text-wrapper.component.html',
  styleUrls: [
    './rich-text-wrapper.component.ed.scss',
    './rich-text-wrapper.component.essent.scss',
  ],
  // We skip hydration here due to a complex bug - see ATL-1840 @ Jira.
  host: { ngSkipHydration: 'true' },
})
export class RichTextWrapperComponent implements OnChanges {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() componentName?: string;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() field?: TextField;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() navigationExtras: NavigationExtras = {
    queryParamsHandling: 'merge',
  };

  readonly #datalayer = inject(DatalayerService);

  constructor(private readonly elementRef: ElementRef) {}

  ngOnChanges(): void {
    setTimeout(() => {
      const nativeElement: HTMLElement = this.elementRef.nativeElement;
      this.updateLinks(nativeElement);
    });
  }

  public updateLinks(nativeElement: HTMLElement) {
    const links: NodeListOf<HTMLLinkElement> =
      nativeElement.querySelectorAll('a[href]');
    links.forEach((link) => {
      link.onclick = (event) => {
        this.trackAnalytics(link, event);
      };
    });
  }

  public trackAnalytics(link: HTMLLinkElement, event: Event) {
    const image = event.target as HTMLImageElement;

    if (link != null) {
      const isButton = link.classList?.contains('btn');
      const eventType =
        image.alt != null ? 'image' : isButton ? 'button' : 'text';

      // Manually push to datalayer since we don't want to depend on the datatracking directives
      this.#datalayer.pushEvent({
        event: isButton ? 'button-click' : 'link-click',
        info: {
          name: link?.href,
          type: eventType,
        },
      });
    }
  }

  getComponentName(rendering: ComponentRendering | undefined) {
    const renderingName =
      rendering != null
        ? getFieldValue<string>(rendering, 'componentName')
        : undefined;
    return renderingName != null ? renderingName : 'unknown-component';
  }
}
